import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, CircularProgress, styled } from "@mui/material";

const StyledMainContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255,255,255,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
}));

export const Loading = ({
  circularProgressSx = {}
}) => {
  const theme = useTheme();

  return (
    <>
      <StyledMainContainer>
        <CircularProgress
          sx={{
            color: theme.palette.primary.mainHover,
            ...circularProgressSx
          }}
        />
      </StyledMainContainer>
    </>
  );
};
